export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11609.724a8043.jpg";